<template>
  <footer class="app-footer m-0">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="logo-header">
            &copy; Italretail S.r.l. {{ moment().format('YYYY') }} - P.IVA 01382910352
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'app-footer'
}
</script>
